module.exports = __webpack_public_path__ + "img/contact-image.7e15fb5c.png";